import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import vuexLocal from "@/plugins/vuex-persist";
import { RootState } from "@/store/types";
import { authModule } from "@/store/modules/auth";
import { sectionModule } from "@/store/modules/section";
import { errorModule } from "@/store/modules/error";
import { contentModule } from "@/store/modules/content";
import { assessmentModule } from "@/store/modules/assessment";
import { practiceModule } from "@/store/modules/practice";
import { demoModule } from "@/store/modules/demo";
import { flowModule } from "@/store/modules/flow";
import { IAuthState } from "./store/modules/auth/types";
import { Config } from "./plugins/config";
import { actions } from "@/store/actions";
import { mutations } from "@/store/mutations";
import { getters } from "@/store/getters";

Vue.use(Vuex);

const storeOption: StoreOptions<RootState> = {
  state: {
    appName: "CCAT CSI",
    appVersion: "0.0.1",
    theme: Config.DefaultTheme,
    isOnline: true,
  },
  actions,
  mutations,
  getters,
  modules: {
    assessmentModule,
    practiceModule,
    demoModule,
    authModule,
    contentModule,
    errorModule,
    flowModule,
    sectionModule,
  },

  // @ts-ignore
  plugins: [vuexLocal.plugin],
};

const store = new Vuex.Store<RootState>(storeOption);

//TODO Create a way to get all initial states from each module
//without need register or import each one manually
const initalAuthState: IAuthState = {
  accessToken: "",
  isLogged: false,
  account: null,
  isCompleted: false,
};

const initialStateCopy = JSON.stringify({
  ...store.state,
  // enforce a clean auth state after reload.
  // It is necessary because the auth data
  // are held and recovery from browser's local storage.
  authModule: initalAuthState,
});

export function resetStore() {
  const state = JSON.parse(initialStateCopy);
  const theme = store.state.theme;
  store.replaceState({ ...state, ...{ theme } });
}

export default store;
